import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";
import useUserAuthentication from "~/hooks/contexts/useUserAuthentication";

export default function AnalyticsHandler() {
  const posthog = usePostHog();
  const { user } = useUserAuthentication();
  const previousUser = useRef<HydratedAuthenticationUser | null>(null);

  useEffect(() => {
    if (posthog.__loaded && user !== undefined && user !== previousUser.current) {
      if (user) {
        posthog.identify(user.id.toString(), {
          email: user.email,
          name: user.name,
          role: user.role,
        });

        posthog.group("organization", user.organization.id.toString(), {
          isOnTrial: user.organization.isOnTrial,
          name: user.organization.name,
          planName: user.organization.plan.name,
        });
      } else {
        posthog.reset();
      }

      previousUser.current = user;
    }
  }, [posthog, user]);

  useEffect(() => {
    if (user) {
      window.rybbit?.identify(user!.id.toString(), {
        email: user!.email,
        name: user!.name,
        organizationIsOnTrial: user!.organization.isOnTrial,
        organizationName: user!.organization.name,
        organizationPlanName: user!.organization.plan.name,
        role: user!.role,
      });
    } else {
      window.rybbit?.clearUserId();
    }
  }, [user]);

  return null;
}
